export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "model": {
          "package_group_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Planeación por pallets"])},
            "num_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cantidad de pallets"])},
            "agro_exporter_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Marca"])},
            "size_pg_plannings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Calibre"])}
          }
        }
      },
      "en": {
        "model": {
          "package_group_planning": {
            "_self": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Package Group Planning"])},
            "num_package_groups": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Number of packages"])},
            "agro_exporter_brand_id": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Brand"])},
            "size_pg_plannings": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Size"])}
          }
        }
      }
    }
  })
}